module.exports = __webpack_public_path__ + "img/bg-圆角底部@2x.e40126bc.png";